import { EstimationStatus } from "../enums/estimation-status";

export const getStatusNameAdmin = (status: EstimationStatus) => {
  switch (status) {
    case EstimationStatus.APPROVED:
      return "Approved";
    case EstimationStatus.APPROVED_WITH_CHANGES:
      return "Approved with Changes";
    case EstimationStatus.MODIFIED:
      return "Pending";
    case EstimationStatus.SUBMITTED:
      return "Pending";
    case EstimationStatus.REJECTED:
      return "Rejected";
    case EstimationStatus.PURCHASED:
      return "Purchased";
    default:
      return "";
  }
};

export const getStatusNameUser = (status: EstimationStatus) => {
  switch (status) {
    case EstimationStatus.PENDING:
      return "Draft";
    case EstimationStatus.APPROVED:
      return "Approved";
    case EstimationStatus.APPROVED_WITH_CHANGES:
      return "Approved with Changes";
    case EstimationStatus.MODIFIED:
      return "Submitted";
    case EstimationStatus.SUBMITTED:
      return "Submitted";
    case EstimationStatus.REJECTED:
      return "Rejected";
    case EstimationStatus.PURCHASED:
      return "Purchased";
    default:
      return "";
  }
};

export const getStatusColor = (status: EstimationStatus) => {
  switch (status) {
    case EstimationStatus.REJECTED:
      return "status-rejected status-rejected-background";
    case EstimationStatus.PENDING:
      return "status-draft status-pending-background";
    case EstimationStatus.MODIFIED:
      return "status-submitted status-modified-background";
    case EstimationStatus.SUBMITTED:
      return "status-submitted status-modified-background";
    default:
      return "status-approved status-approved-background";
  }
};
